import { mapGetters } from "vuex"
import { getCountryList, getStateList } from '@/libs/api/api';
import { isEmpty, cloneDeep, filter, find } from 'lodash';

export default {
    data () {
        return {
            countries: [],
            states: [],
            selectedState: {},
            validatePostalCode: this.validatePostalCodeFunction,
            searchState: ''
        }
    },
    computed: {
        ...mapGetters({
            countryList: 'getCountryList'
        }),
        isShowStateField () {
            return !isEmpty(this.states)
        }
    },
    mounted () {
        this.fetchCountries()
    },
    methods: {
        async fetchCountries () {
            if (isEmpty(this.countryList)) {
                let response = await getCountryList();
                this.countries = (response && response.list) || [];
                this.$store.dispatch('setCountryList', this.countries);
            } else {
                this.countries = cloneDeep(this.countryList)
            }
        },

        /**
         * fetch state list
         */
        async fetchStateList (country) {
            if (!isEmpty(country)) {
                let response = await getStateList(country._id)
                this.states = (response && response.list) || [];
            } 
        },

        querySearchState: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) { 
                return 
            }
            let results = []
            if (!isEmpty(this.states)) {
                results = await filter(this.states, (state) => {
                    if (state.state_code.toLowerCase().includes(search.toLowerCase()) || state.state_name.toLowerCase().includes(search.toLowerCase())) return state
                })
            }
            cb(results)
        },
        handleStateSelect(item) {
            this.selectedState = item
            this.searchState = item.state_code
        },

        enterStateCode (search) {
            if (search !== '');
            const foundState = find(this.states, {state_code: (search.toUpperCase() || search.toLowerCase())});
            if (foundState) {
                this.selectedState = foundState;
                this.searchState = foundState.state_code
            }
        },

        /**
         * validate postal code
         * @param {*} rule 
         * @param {*} value 
         * @param {*} callback 
         */
         validatePostalCodeFunction (rule, value, callback) {
            let regex = ''
            if (this.address.country_code && this.address.country_code !== '') {
                // find the address code and regex
                const code = find(this.countryList, {country_code: this.address.country_code})
                regex = (code && code.postal_regex) || ''
            }
            // validate postal code on basis of regex
            if (regex !== '' && value && value !== '' && !new RegExp(regex).test(value)) callback(new Error('Invalid Postal code'))
            else callback()
        },
    }
}